// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/fonts/FFClanProCondRgNews.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/fonts/FFClanProRegular.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/fonts/FFClanProMedium.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Assets/fonts/allFonts/FFClanProBold.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Assets/fonts/allFonts/FFClanProBlk.TTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "Clans Pro";
	font-weight: 300;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
	font-family: "Clans Pro";
	font-weight: 400;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
	font-family: "Clans Pro";
	font-weight: 500;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
	font-family: "Clans Pro";
	font-weight: 700;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
	font-family: "Clans Pro";
	font-weight: 900;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,+DAAmE;AACpE;AACA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,+DAAgE;AACjE;AACA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,+DAA+D;AAChE;AACA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,+DAAsE;AACvE;AACA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,+DAAqE;AACtE","sourcesContent":["@font-face {\n\tfont-family: \"Clans Pro\";\n\tfont-weight: 300;\n\tsrc: url(./Assets/fonts/FFClanProCondRgNews.TTF) format(\"truetype\");\n}\n@font-face {\n\tfont-family: \"Clans Pro\";\n\tfont-weight: 400;\n\tsrc: url(./Assets/fonts/FFClanProRegular.TTF) format(\"truetype\");\n}\n@font-face {\n\tfont-family: \"Clans Pro\";\n\tfont-weight: 500;\n\tsrc: url(./Assets/fonts/FFClanProMedium.TTF) format(\"truetype\");\n}\n@font-face {\n\tfont-family: \"Clans Pro\";\n\tfont-weight: 700;\n\tsrc: url(./Assets/fonts/allFonts/FFClanProBold.TTF) format(\"truetype\");\n}\n@font-face {\n\tfont-family: \"Clans Pro\";\n\tfont-weight: 900;\n\tsrc: url(./Assets/fonts/allFonts/FFClanProBlk.TTF) format(\"truetype\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
